import dayjs from 'dayjs';
import { type DateTimeFormatOptions } from 'next-intl';

type Options = {
  relative?: boolean;
  formatOptions?: DateTimeFormatOptions;
};

export const useFormattedDate = (
  date: Date | string,
  options: Options = {},
) => {
  const {
    relative = false,
    formatOptions = {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
    },
  } = options;

  // const format = useFormatter();
  const now = new Date();

  const convertedDate = typeof date === 'string' ? new Date(date) : date;

  if (relative) {
    const weeksDiff = dayjs().diff(date, 'week');

    return weeksDiff;
  } else {
    return convertedDate.toDateString();
  }
};
